import React from 'react';

import { type IWithChildren } from '../../types/interfaces';
import { type StepsInterface, useStepContext } from './step-context-provider';

export const Step = ({ children }: IWithChildren<(props: StepsInterface) => React.ReactNode>) => {
    const { moveToNextStep, moveToPrevStep, moveToBeginning } = useStepContext();
    return <div>{children({ moveToNextStep, moveToPrevStep, moveToBeginning })}</div>;
};
